
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiOwnShipNoCommandZ as ObiOwnShipNoCommandZElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-own-ship-no-command-z.js';
 
 
 

 
 export const ObiOwnShipNoCommandZ = createComponent({
   react: React,
   tagName: 'obi-own-ship-no-command-z',
   elementClass: ObiOwnShipNoCommandZElement,
   events: {
     
   }
  });
 
 